module.exports = __webpack_public_path__ + "fonts/segoeuib.299556ce.ttf";